import { BusinessDetail } from "./BusinessDetail";
import { CompanyDetail } from "./CompanyDetail";
import { IndividualDetail } from "./IndividualDetail";
export class BusinessDetailFactory {
  static create($type) {
    if ($type === "V1.CompanyInfo.BusinessDetail") {
      const result = new BusinessDetail();
      return result;
    }
    if ($type === "V1.CompanyInfo.CompanyDetail") {
      const result = new CompanyDetail();
      return result;
    }
    if ($type === "V1.CompanyInfo.IndividualDetail") {
      const result = new IndividualDetail();
      return result;
    }
    throw new Error($type + " not found");
  }
}
